export const simulateMouseClick = async (el: any) => {
  const opts = { view: window, bubbles: true, cancelable: true, buttons: 1 }
  el.dispatchEvent(new MouseEvent('mousedown', opts))
  await new Promise((r) => setTimeout(r, 50))
  el.dispatchEvent(new MouseEvent('mouseup', opts))
  el.dispatchEvent(new MouseEvent('click', opts))
}

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
